export const areaCodeList = [
  {
    label: '+86',
    value: '86',
    reg: /^1[3-9]\d{9}$/,
    len: 11,
    title: '大陆'
  },
  {
    label: '+852',
    value: '852',
    reg: /^[5689]\d{7}$/,
    len: 8,
    title: '香港'
  },
  {
    label: '+853',
    value: '853',
    reg: /^6\d{7}$/,
    len: 8,
    title: '澳门'
  },
  {
    label: '+886',
    value: '886',
    reg: /^09\d{8}$/,
    len: 10,
    title: '台湾'
  },
]
